import React from "react";
import { useNavigate } from "react-router-dom";
import { useEditMode } from "../../../context-controller-mod/context-serv/global-provider/dirty-provider/dirtyModeProvider";
import { useGlobalPopupProvider } from "../../../context-controller-mod/context-serv/popup-provider/ts/globalPopupProvider";
import { Confirmation, Button } from "@core/uilibrary";
import { DocConfirmationIcon } from "../../../asset-controller-mod/asset-serv/icons/iconExporter";

export function useSafeNavigate() {
  const navigate = useNavigate();
  const { isEditing, setEditing } = useEditMode();
  const { openConfirm, closeConfirm } = useGlobalPopupProvider();

  return (
    to: string,
    options?: any,
    onConfirmNavigate?: () => void
  ) => {
    const proceed = () => {
      onConfirmNavigate?.();
      setEditing(false);
      navigate(to, options);
    };

    if (!isEditing) {
      proceed();
      return;
    }

    openConfirm(
      <Confirmation
        visible
        title="Unsaved changes"
        description="Routing or reloading this page may reset unsaved data or interrupt the current action."
        status="warning"
        onClose={closeConfirm}
        icon={<DocConfirmationIcon/>}
        buttons={
          <>
            <Button
              variant="ghost"
              size="md"
              value="Cancel"
              onClick={closeConfirm}
            />

            <Button
              variant="primary"
              size="md"
              value="Confirm"
              onClick={() => {
                closeConfirm();
                proceed();
              }}
            />
          </>
        }
      />
    );
  };
}